import React, { useEffect, useRef, useState } from 'react'
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore"
import { auth, db } from '../firebase';
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";

import d4 from './SubscriptionForm.module.css'

import { FaRegMoneyBillAlt, FaBoxOpen } from 'react-icons/fa'
import { HiIdentification, HiOutlineDownload } from 'react-icons/hi'
import { MdPermPhoneMsg } from 'react-icons/md'
import { IoArrowBack } from 'react-icons/io5'

import omt from './media/omt.jpeg'
import whish from './media/whish money.jpeg'
import logo from './media/questa logo.png'

import { useNavigate } from 'react-router-dom';
import MiniLoader from './ui/Visual-utilities/MiniLoader';
import BlueButton from './ui/BlueButton';
function SubscriptionForm() {
  const hist = useNavigate();
  const [paymentRequestStatus, setPaymentRequestStatus] = useState(false)

  const phoneRef = useRef();
  const fullNameRef = useRef();
  const paymentRef = useRef();
  const packageRef = useRef();

  const [reciept, setReciept] = useState('');
  const [miniLoad, setMiniLoad] = useState(false);
  const [enteredPhone, setEnteredPhone] = useState('');
  const [enteredName, setEnteredName] = useState('');
  const [enteredPayment, setEnteredPayment] = useState('');
  const [enteredTime, setEnteredTime] = useState(0);
  const [enteredPackage, setEnteredPackage] = useState({ name: '', credits: '', price: '' });

  const [loadingPackages, setloadingPackages] = useState(true);
  const [packages, setPackages] = useState([]);

  function onChangeValue() {
    setEnteredPhone(phoneRef.current.value)
    setEnteredName(fullNameRef.current.value)
    setEnteredPayment(paymentRef.current.value || '')
    setEnteredPackage(packages[packageRef.current.value])
    let today = new Date();
    let date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    setEnteredTime(date + ' ' + time)

    console.log('entered pckg', enteredPackage)
  }




  useEffect(() => {
    setloadingPackages(true);
    async function getPackages() {


      const docRef = doc(db, "subscriptionPackages", "packages");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setPackages(docSnap.data().packages)
        console.log(" data:", packages);
        setloadingPackages(false)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

    }
    getPackages()
  }, []);


  async function addToDatabase() {
    setMiniLoad(true);

    const addedDoc = await addDoc(collection(db, "payments"), {//auto generated id //create/overwrite

      account_id: auth.currentUser.uid,
      account_name: auth.currentUser.displayName,
      phone: enteredPhone,
      payment_method: enteredPayment,
      full_name_by_id: enteredName,
      createdAt: serverTimestamp(),
      payment_status: 'pending',
      package: enteredPackage,
    });
    await setReciept(addedDoc.id);
    console.log('new added doc id: ' + addedDoc.id);
    await generatePDF(addedDoc.id);
    setPaymentRequestStatus(true);
    setMiniLoad(false);
  }



  /*html2canvas 1.2.0   and jspdf 2.1.0  worked*/
  const generatePDF = (s) => {
    //const s='erger'+reciept;
    const domElement = document.getElementById('content');
    html2canvas(domElement).then(canvas => {

      let imgHeight, imgWidth;
      let ratio = canvas.height / canvas.width;

      if (ratio <= 1.414) {
        //fit width 595.35 x 841.995
        imgWidth = 595.35;
        imgHeight = imgWidth * ratio;
      }
      else {
        //fit height
        imgHeight = 841.995;
        imgWidth = imgHeight / ratio;
      }
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.setFontSize(20);
      pdf.setTextColor(255, 0, 0);

      pdf.text(10, 20, s);

      pdf.save('Questa Payment Request ' + auth.currentUser.displayName + '.pdf');
    });
  };



  function click(e) {
    e.preventDefault();
    addToDatabase();
  }

  let paymentProvider = {
    omt: {
      img: omt,
      rate: 3,
    },
    whish: {
      img: whish,
      rate: 1,
    },

  }

  function pp(providerName) { return providerName === "OMT" ? paymentProvider.omt : paymentProvider.whish }

  return (

    <div className={d4.container}>
      <div className={d4.backButtonContainer}> <button onClick={() => { hist(-1) }} className={d4.backButton}><IoArrowBack size='30' /></button></div>

      <section>
        <form onSubmit={click} >

          <div className={d4.title}>  <FaRegMoneyBillAlt className={d4.formIcons} /> Select your payment method:</div>
          <select onChange={onChangeValue} ref={paymentRef} required>
            <option value="" defaultValue hidden>Choose payment method</option>
            <option value='OMT'>OMT</option>
            <option value='Whish Money'> Whish Money</option>
          </select>

          <div className={d4.title}>  <FaBoxOpen className={d4.formIcons} /> Select your package:</div>
          <select onChange={onChangeValue} ref={packageRef} required>
            <option value="" defaultValue hidden>{loadingPackages ? 'loading packages...' : 'Choose your package'}</option>
            {packages.length !== 0 && packages.map((p, index) => {
              return <option key={index} value={index}>{p.name}</option>
            })}

          </select>

          <div className={d4.title}>  <MdPermPhoneMsg className={d4.formIcons} /> Enter Phone Number:</div>
          <p className={d4.explanation}>This is the phone number you will be using to comfirm the payment</p>
          <p> <b>+961</b>  <input type='tel' pattern="[0-9]{2}[0-9]{3}[0-9]{3}" required ref={phoneRef} placeholder='Phone Number' /></p>




          <div className={d4.title}>  <HiIdentification className={d4.formIcons} /> Enter Full Name:</div>
          <p className={d4.explanation}>This is the name you will be using to send the payment</p>
          <input onChange={onChangeValue} ref={fullNameRef} required type='span' placeholder='full name' />



          {paymentRequestStatus ?
            <div className={d4.paymentSuccess}> Payment Request successfully sent!
              <p> Your account will be activated as soon as you pay the subscription fees, thank you</p>
            </div> :
            <BlueButton type='submit' id="ignorePDF">Download Receipt<HiOutlineDownload />{miniLoad && <MiniLoader />}</BlueButton>}

        </form>
      </section>

      <hr />

      <section>
        <div id='content' className={d4.content}>
          <img className={d4.logo} src={logo} alt='logo' />

          <div className={d4.recieptId}>{reciept}</div>
          <div className={d4.ReceiveTitle}>Payment request for a 1 month subscription on <b>questa.education</b>:</div>
          <br />
          <div className={d4.SubscribingAccount}>
            Subscribing Account:
            <p>Account id:<span className={d4.Values}> {auth.currentUser.uid}</span></p>
            <p>Account name:<span className={d4.Values}> {auth.currentUser.displayName}</span></p>
          </div>

          <br />
          <p>Payment method:<span className={d4.Values}> {enteredPayment}</span>
            <img className={d4.payment_img} alt='omt' src={pp(enteredPayment).img} /></p>

          <div className={d4.Sender}>
            Sender:
            <p>Full name by ID:<span className={d4.Values}> {enteredName}</span></p>
            <p>Phone number:<span className={d4.Values}> {enteredPhone}</span></p>
          </div>
          <br />
          <div className={d4.Reciever}>
            Reciever:
            <p>Full name by ID:<span className={d4.Values}> Anthony Sakher Kreidy</span></p>
            <p>Phone number:<span className={d4.Values}> 81 184 763</span></p>
          </div>
          <br />
          <div className={d4.Reciever}>
            Packages details:
            <p>Name:<span className={d4.Values}> {enteredPackage && enteredPackage.name}</span></p>
            <p>Credits:<span className={d4.Values}> {enteredPackage && enteredPackage.credits}</span></p> <p>Amount:<span className={d4.Values}> {enteredPackage && enteredPackage.price}</span></p>
            <p>Transactional fees <span className={d4.Values}> +{pp(enteredPayment).rate}$</span></p>
            <hr />
            <p>Total:<span className={d4.Values}> {Boolean(enteredPackage) && (parseInt(enteredPackage.price) + pp(enteredPayment).rate)}$</span></p>

          </div>
          <br />
          <p>Created At:<span className={d4.Values}>{enteredTime}</span></p>

        </div>


      </section>
    </div>


  )
}

export default SubscriptionForm
